import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import {
  Table,
  Input,
  Breadcrumb,
  Button,
  Space,
  Select,
  Popconfirm,
  Tooltip,
  Form,
} from "antd";
import { debounce } from "lodash";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import { ReactComponent as ArchiveButtonicon } from "../../image/ArchiveButtonicon.svg";
import { UndoOutlined } from "@ant-design/icons";

const EmployeeList = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const { Option } = Select;

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  useEffect(() => {
    const getEmployeeList = async () => {
      setLoading(true);

      try {
        const params = {
          ...state, // existing state: page, pagesize, search, ordering
          fields:
            "id,name,role_name,email,street_address,suburb,state,postcode,additional_details,phone,company_name,abn_number,work_on,tax_file_number,account_holder_name,status", // add the fields param
        };
        let apiResponse = await getRequest("employee/exclude-drivers/", params);

        if (apiResponse?.data?.results?.success) {
          setEmployeeList(apiResponse?.data?.results?.data);

          settotalCount(apiResponse.data.count);
          const categories = {};
          apiResponse.data.results.data.forEach((employee) => {
            const categoriesForEmployee = employee.category_tree.map(
              (category) => category.category_tree_name
            );
            categories[employee.id] = categoriesForEmployee;
          });
        } else {
          // ErrorNotificationMsg(t("error_in_employee_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getEmployeeList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company_name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company_name";
    }
    if (sortField === "name" && sortOrder === "ascend") {
      sortingEnumKey = "name";
    }
    if (sortField === "name" && sortOrder === "descend") {
      sortingEnumKey = "-name";
    }
    if (sortField === "role" && sortOrder === "ascend") {
      sortingEnumKey = "user__groups__name";
    }
    if (sortField === "role" && sortOrder === "descend") {
      sortingEnumKey = "-user__groups__name";
    }

    if (sortField === "address" && sortOrder === "ascend") {
      sortingEnumKey = "address";
    }
    if (sortField === "address" && sortOrder === "descend") {
      sortingEnumKey = "-address";
    }

    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }

    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }

    if (sortField === "work_on" && sortOrder === "ascend") {
      sortingEnumKey = "work_on";
    }
    if (sortField === "work_on" && sortOrder === "descend") {
      sortingEnumKey = "-work_on";
    }
    if (sortField === "abn_number" && sortOrder === "ascend") {
      sortingEnumKey = "abn_number";
    }
    if (sortField === "abn_number" && sortOrder === "descend") {
      sortingEnumKey = "-abn_number";
    }
    if (sortField === "tax_file_number" && sortOrder === "ascend") {
      sortingEnumKey = "tax_file_number";
    }
    if (sortField === "tax_file_number" && sortOrder === "descend") {
      sortingEnumKey = "-tax_file_number";
    }
    if (sortField === "account_holder_name" && sortOrder === "ascend") {
      sortingEnumKey = "account_holder_name";
    }
    if (sortField === "account_holder_name" && sortOrder === "descend") {
      sortingEnumKey = "-account_holder_name";
    }

    if (sortField === "account_number" && sortOrder === "ascend") {
      sortingEnumKey = "account_number";
    }
    if (sortField === "account_number" && sortOrder === "descend") {
      sortingEnumKey = "-account_number";
    }

    if (sortField === "bank_name" && sortOrder === "ascend") {
      sortingEnumKey = "bank_name";
    }
    if (sortField === "bank_name" && sortOrder === "descend") {
      sortingEnumKey = "-bank_name";
    }

    if (sortField === "branch_name" && sortOrder === "ascend") {
      sortingEnumKey = "branch_name";
    }
    if (sortField === "branch_name" && sortOrder === "descend") {
      sortingEnumKey = "-branch_name";
    }

    if (sortField === "ifsc_code" && sortOrder === "ascend") {
      sortingEnumKey = "ifsc_code";
    }
    if (sortField === "ifsc_code" && sortOrder === "descend") {
      sortingEnumKey = "-ifsc_code";
    }

    if (
      sortField === "emergency_contact_person_name" &&
      sortOrder === "ascend"
    ) {
      sortingEnumKey = "emergency_contact_person_name";
    }
    if (
      sortField === "emergency_contact_person_name" &&
      sortOrder === "descend"
    ) {
      sortingEnumKey = "-emergency_contact_person_name";
    }

    if (sortField === "emergency_contact_person_no" && sortOrder === "ascend") {
      sortingEnumKey = "emergency_contact_person_no";
    }
    if (
      sortField === "emergency_contact_person_no" &&
      sortOrder === "descend"
    ) {
      sortingEnumKey = "-emergency_contact_person_no";
    }

    if (sortField === "visa_type" && sortOrder === "ascend") {
      sortingEnumKey = "visa_type";
    }
    if (sortField === "visa_type" && sortOrder === "descend") {
      sortingEnumKey = "-visa_type";
    }

    if (sortField === "driving_license" && sortOrder === "ascend") {
      sortingEnumKey = "driving_license";
    }
    if (sortField === "driving_license" && sortOrder === "descend") {
      sortingEnumKey = "-driving_license";
    }

    if (sortField === "term_condition_accept" && sortOrder === "ascend") {
      sortingEnumKey = "term_condition_accept";
    }
    if (sortField === "term_condition_accept" && sortOrder === "descend") {
      sortingEnumKey = "-term_condition_accept";
    }

    if (sortField === "police_check" && sortOrder === "ascend") {
      sortingEnumKey = "police_check";
    }
    if (sortField === "police_check" && sortOrder === "descend") {
      sortingEnumKey = "-police_check";
    }

    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }

    return sortingEnumKey;
  };
  const handleStatus = async (user_id, status) => {
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("pop_employee_status_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(user_id, status),
        },
        {
          label: t("confirmAlert_cancel"),
          onClick: () => navigate("/employee"),
        },
      ],
    });
  };

  const changeStatus = async (id, value) => {
    setLoading(true);
    await patchRequest(`employee-status-change/${id}/`, { status: value })
      .then((response) => {
        SuccessNotificationMsg(t("status_updated_sucessfully"));
        setReload(!reload);
      })
      .catch((error) => {
        // Handle error here (e.g., show an error notification)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("employee/archive-employee/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;
        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("employee_archive_successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 120,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Role",
      dataIndex: "role_name",
      key: "role",
      sorter: true,
      width: 150,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
      sorter: true,
      width: 230,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Street Address",
      dataIndex: "street_address",
      key: "street_address",
      sorter: true,
      width: 250,
      // render: (text) => (
      //   <Tooltip title={text}>
      //     <span>{text}</span>
      //   </Tooltip>
      // ),
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: true,
      width: 120,
    },
    {
      title: "Postcode",
      dataIndex: "postcode",
      key: "postcode",
      sorter: true,
      width: 120,
    },
    {
      title: "Suburb",
      dataIndex: "suburb",
      key: "suburb",
      sorter: true,
      width: 120,
    },
    {
      title: "Additional Details",
      dataIndex: "additional_details",
      key: "additional_details",
      sorter: true,
      width: 200,
      // render: (text) => (
      //   <Tooltip title={text}>
      //     <span>{text}</span>
      //   </Tooltip>
      // ),
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Contact Number",
      dataIndex: "phone",
      key: "phone",
      width: 150,
      render: (phone) => {
        if (phone) {
          const cleanedPhone = String(phone).replace(/\D/g, "");

          if (cleanedPhone.startsWith("91")) {
            return `+91 ${cleanedPhone.slice(2, 7)} ${cleanedPhone.slice(7)}`;
          } else {
            return `+${cleanedPhone}`;
          }
        }
        return null;
      },
      sorter: true,
    },

    {
      title: "Work On",
      dataIndex: "work_on",
      key: "work_on",
      sorter: true,
      width: 160,
    },
    {
      title: "ABN Number",
      dataIndex: "abn_number",
      key: "abn_number",
      sorter: true,
      width: 130,
    },
    {
      title: "Tax File Number",
      dataIndex: "tax_file_number",
      key: "tax_file_number",
      sorter: true,
      width: 120,
    },
    {
      title: "Account Holder Name",
      dataIndex: "account_holder_name",
      key: "account_holder_name",
      sorter: true,
      width: 160,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      fixed: "right",
      width: 250,
      render: (e, record) => (
        <div className="SelectStatusSec">
          <Select
            value={e ? e : record.status}
            onChange={(e) => handleStatus(record.id, e)}
            defaultValue={e}
          >
            <Option value="Pending" disabled>
              {" "}
              <div className="discardopt">{t("pending")}</div>
            </Option>
            <Option value="Active">
              {" "}
              <div className="dealdoneopt">{t("active")}</div>
            </Option>
            <Option value="Inactive">
              {" "}
              <div className="contactedopt">{t("inactive")}</div>
            </Option>
          </Select>
        </div>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          {/* <Tooltip
            color={colors}
            placement="left"
            title={<span style={{ color: "#fff" }}>Edit</span>}
          > */}
          <Link
            to={{
              pathname: "/employee/edit/" + btoa(record.id),
            }}
          >
            {authUserData()?.permission.includes(
              "employee|change_employee"
            ) && <Editicon onClick={() => handleEdit(record.id)} />}
          </Link>
          {/* </Tooltip> */}
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Archive</span>}
          > */}
          {authUserData()?.permission.includes("employee|delete_employee") && (
            <Popconfirm
              className="action"
              title={t("pop_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleArchive(record.id)}
            >
              <Archive style={{ cursor: "pointer" }} />
            </Popconfirm>
          )}
          {/* </Tooltip> */}
        </Space>
      ),
    },
  ];

  const handleEdit = (id) => {};

  const colors = ["#737373"];
  return (
    <>
      <div className="mainwrapper">
        <div className="ListingTopBar">
          <div className="pagenamewrap">
            <div className="pagename">
              {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & Manage The List Of Employees Within The Organization.
                </span>
              }
            > */}
              <h3>{t("pl_employeeListing")}</h3>
              {/* </Tooltip> */}

              <Breadcrumb className="Breadcrumb-Sec">
                <Breadcrumb.Item>
                  <Link to="/dashboard">{t("home")}</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{t("employeeList")}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Space>
              <div className="searchwrp">
                <Space direction="vertical">
                  <Form form={form}>
                    <Form.Item name="search" initialValue="">
                      <Search
                        prefix={
                          <img
                            src={SearchIcon}
                            alt="SearchIcon"
                            className="SearchIcon"
                            width={22}
                          />
                        }
                        placeholder={t("pl_search_list")}
                        onChange={searchCallbackDelayed}
                      />
                    </Form.Item>
                  </Form>
                </Space>
              </div>
              {state?.search ? (
                // <Tooltip title="Reset search">
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  onClick={() => handleReset()}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                    Reset
                  </span>
                </Button>
              ) : (
                // </Tooltip>
                ""
              )}

              {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Employee To The Organization&apos;s Database.
                </span>
              }
            > */}
              {authUserData()?.permission.includes("employee|add_employee") && (
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  onClick={() => navigate("/employee/add")}
                  icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                >
                  {t("pl_add_employee")}
                </Button>
              )}
              {/* </Tooltip>
               */}
              {authUserData()?.permission.includes(
                "employee|delete_employee"
              ) && (
                <>
                  {selectedRow.length > 0 && (
                    <Popconfirm
                      className="action"
                      title={t("pop_title")}
                      okText={t("pop_ok")}
                      cancelText={t("pop_cancel")}
                      placement="left"
                      onConfirm={() => handleArchive()}
                    >
                      <ButtonField
                        className="BlueShadowBtn"
                        type="primary"
                        htmlType="button"
                        label={
                          <div
                            className="BlueShadowBtn"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <ArchiveButtonicon />
                            <span>{t("pl_archive")}</span>
                          </div>
                        }
                      />
                      {/* <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    label={
                      <>
                        <div
                          className="BlueShadowBtn"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <ArchiveButtonicon />
                          <span>{t("pl_archive")}</span>
                        </div>
                      </>
                    }
                  /> */}
                    </Popconfirm>
                  )}
                </>
              )}
              {authUserData()?.permission.includes(
                "employee|delete_employee"
              ) && (
                // <Tooltip placement="topLeft" title="View Archived Records">
                <Link className="Archiveicon" to="/employee/archive">
                  <Archiveicon />
                </Link>
                // </Tooltip>
              )}
            </Space>
          </div>
        </div>
        <section className="grid-sec">
          <div className="Package-body">
            <div className="tablewrp">
              <Table
                className="fixedcol"
                scroll={{
                  x: 1000,
                }}
                rowSelection={rowSelection}
                columns={columns}
                rowKey={(record) => record.id}
                dataSource={employeeList}
                loading={loading}
                pagination={{
                  defaultCurrent: state.page,
                  defaultPageSize: state.pagesize,
                  total: totalCount,
                  showTotal: (total) => `Total ${total} items`,
                  showSizeChanger: true,
                  locale: {
                    items_per_page: "Items / Page",
                  },
                }}
                onChange={handleTableChange}
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default EmployeeList;
